module.exports = __webpack_public_path__ + "static/media/iconfinder_trello_2317760.2996cf54.svg";